const print = {
  state: {
    printId:1,
    printStatus:-1,
    printer: [],
  },

  mutations: {
    SET_PRINTID: (state, printId) => {
      state.printId = printId
    },
    SET_PRINTSTATUS: (state, printStatus) => {
      state.printStatus = printStatus
    },
    SET_PRINTER: (state, printer) => {
      state.printer = printer
    },
  },

  actions: {
    setPrintId({ commit }, printId) {
      commit('SET_PRINTID', printId)
    },
    setPrintStatus({ commit }, printStatus) {
      commit('SET_PRINTSTATUS', printStatus)
    },
    setPrinter({ commit }, printer) {
      commit('SET_PRINTER', printer)
    },
  }
}

export default print
